import { PaginatedResponse } from '@frontend/api-utils';
import { Application, Feature } from '@frontend/functionality/types';

import { PackageStateName } from './package-state';

export interface Package {
    delete_timestamp: string | null;
    iot_id: string | null;
    user_id: string | null;
    product_id: string | null;
    equipment_id: string | null;
    colli_id: string | null;
    spot_id: string | null;
    module_id: string;
    slot_id: string;
    quantity: number;
    state: PackageStateName;
    application: Application;
    feature: Feature;
    priority: number;
    budget_id: string | null;
    cost_center_id: string | null;
    blocking: boolean;
    dependent_package_id: string | null;
    require_proof_of_identity: boolean;
    update_timestamp: string;
    workflow_id: string;
    type: PackageType;
    id: string;
    account_id: string;
    transaction_id: string;
    creation_timestamp: string;
}

export interface CreatePackage {
    iot_id?: string | null;
    user_id?: string | null;
    product_id?: string | null;
    equipment_id?: string | null;
    colli_id?: string | null;
    spot_id?: string;
    module_id?: string;
    slot_id?: string;
    quantity?: number;
    state?: PackageStateName;
    application?: Application | null;
    feature?: Feature | null;
    priority?: number;
    budget_id?: string | null;
    cost_center_id?: string | null;
    blocking?: boolean | null;
    dependent_package_id?: string | null;
    require_proof_of_identity?: boolean;
    workflow_id?: string;
    type: PackageType;
    from_entity_type?: string | null;
    from_entity_id?: string | null;
}

export interface UpdatePackage {
    null_fields?: string[] | null;
    iot_id?: string | null;
    user_id?: string | null;
    product_id?: string | null;
    equipment_id?: string | null;
    colli_id?: string | null;
    spot_id?: string | null;
    module_id?: string | null;
    slot_id?: string | null;
    quantity?: number | null;
    state?: PackageStateName | null;
    application?: Application | null;
    feature?: Feature | null;
    priority?: number | null;
    budget_id?: string | null;
    cost_center_id?: string | null;
    blocking?: boolean | null;
    dependent_package_id?: string | null;
    require_proof_of_identity?: boolean | null;
}

export type PackageListResponse = PaginatedResponse<Package>;

export enum PackageQueryParams {
    IOT_ID = 'iot_id',
    PRODUCT_ID = 'product_id',
    STATE = 'state',
    WORKFLOW_ID = 'workflow_id',
    SPOT_ID = 'spot_id',
    MODULE_ID = 'module_id',
    SLOT_ID = 'slot_id',
    TRANSACTION_ID = 'transaction_id',
    COLLI_ID = 'colli_id',
    ID = 'id',
    TYPE = 'type'
}

export enum PackageType {
    AUDIT = 'audit',
    DROP_OFF = 'drop_off',
    PICK_UP = 'pick_up',
    PASS_THROUGH = 'pass_through',
    REMOVAL = 'removal'
}

export interface UpdatePackageState {
    state?: PackageStateName;
}
